import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (n) => Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });

/**
 * Horizontal stat strips shown at the top of the Manager (محمد حسين) dashboard.
 * Pure number widgets — no icons, just colored labeled rows so the user gets a
 * quick financial pulse: capital, profit, expenses, inventory value, customer debts.
 */
const HRSummaryStrips = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/admin/hr-summary`);
      setData(data);
    } catch {
      // silent — keep previous values
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000); // refresh every 30s
    return () => clearInterval(t);
  }, []);

  const strips = [
    { key: "total_capital", label: "رأس المال الكلي", value: data?.total_capital },
    { key: "total_profit", label: "الأرباح الكلية", value: data?.total_profit },
    { key: "total_expenses", label: "المصاريف الكلية", value: data?.total_expenses },
    { key: "inventory_value", label: "قيمة المواد بالمخزن (بسعر الشراء)", value: data?.inventory_value, sub: data ? `${fmt(data.products_count)} مادة` : null },
    { key: "customer_debts", label: "مديونية الزبائن", value: data?.customer_debts, sub: data ? `${fmt(data.debtors_count)} زبون` : null },
    { key: "supplier_debts", label: "مديونية المجهّزين", value: data?.supplier_debts, sub: data ? `${fmt(data.suppliers_count)} مُجهّز` : null },
  ];

  return (
    <div data-testid="hr-summary-strips" dir="rtl">
      <div className="bg-gradient-to-l from-[#0B2A55] to-[#1E40AF] text-white rounded-2xl p-4 mb-3">
        <h3 className="font-bold text-lg flex items-center gap-2">📊 الملخص المالي</h3>
        <p className="text-xs opacity-90 mt-1">نظرة شاملة على المؤشرات المالية للحساب — تحديث تلقائي كل 30 ثانية.</p>
      </div>
      <div className="space-y-2">
        {strips.map((s) => (
        <div
          key={s.key}
          data-testid={`hr-strip-${s.key}`}
          className="rounded-xl overflow-hidden shadow-sm border-2 border-white transition-transform hover:scale-[1.005]"
        >
          <div
            className="flex items-center justify-between gap-3 px-4 py-3 text-white"
            style={{ background: "linear-gradient(to left, #0B2A55, #1E40AF)" }}
          >
            <div className="flex flex-col min-w-0">
              <span className="text-sm sm:text-base font-bold truncate">{s.label}</span>
              {s.sub && <span className="text-[10px] sm:text-xs opacity-80 mt-0.5" dir="ltr">{s.sub}</span>}
            </div>
            <span
              className="text-2xl sm:text-3xl font-black bg-white text-[#0B2A55] rounded-2xl px-5 py-1.5 shadow-md tracking-tight whitespace-nowrap shrink-0"
              dir="ltr"
              data-testid={`hr-strip-value-${s.key}`}
              style={{ textShadow: "0 1px 0 rgba(255,255,255,0.4)" }}
            >
              {loading && !data ? "…" : `${fmt(s.value)} د.ع`}
            </span>
          </div>
        </div>
      ))}
      </div>
    </div>
  );
};

export default HRSummaryStrips;
